module.exports = __webpack_public_path__ + "static/media/ares.890d04ff.webp";